/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface GradeTaskRequestContent
 */
export interface GradeTaskRequestContent {
    /**
     * Grade percentage to assign to the task
     * @type {number}
     * @memberof GradeTaskRequestContent
     */
    percentage: number;
}


/**
 * Check if a given object implements the GradeTaskRequestContent interface.
 */
export function instanceOfGradeTaskRequestContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "percentage" in value;
    return isInstance;
}

export function GradeTaskRequestContentFromJSON(json: any): GradeTaskRequestContent {
    return GradeTaskRequestContentFromJSONTyped(json, false);
}

export function GradeTaskRequestContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): GradeTaskRequestContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'percentage': json['percentage'],
    };
}

export function GradeTaskRequestContentToJSON(value?: GradeTaskRequestContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'percentage': value.percentage,
    };
}

